module.exports = __webpack_public_path__ + "static/media/slide12.c6f01c98.jpg";